module.exports = __webpack_public_path__ + "static/media/8.86cbb3bc.jpeg";